



























import {Component, Prop, Vue} from "vue-property-decorator";

@Component({ name: "import-grid-report" })
export default class ImportGridReport extends Vue {
  @Prop() reportData: {result: string, total: number, report: {status: string, row: object, num: number, exist: boolean, messages: string[]}[]};
}
